/**
 * Locale-aware navigation hook.
 *
 * Kullanım:
 *   const { r, nav, link } = useRoutes();
 *   <Link to={r('play')}>Oyna</Link>
 *   nav('education', 'x-wing');
 *   <Link to={link('daily')}>Günlük</Link>
 */

import { useCallback } from 'react';
import { useNavigate, type NavigateOptions } from 'react-router-dom';
import { useI18n } from '../i18n';
import { routeFor, type RouteKey } from '../i18n/routes';

export function useRoutes() {
  const { locale } = useI18n();
  const navigate = useNavigate();

  const r = useCallback(
    (key: RouteKey, param?: string | number) => routeFor(locale, key, param),
    [locale]
  );

  const nav = useCallback(
    (key: RouteKey, param?: string | number, options?: NavigateOptions) => {
      navigate(routeFor(locale, key, param), options);
    },
    [locale, navigate]
  );

  return { r, nav, link: r, locale };
}
